/**
 * ActiveModifierBadge — small HUD badge shown during gameplay when a world modifier is active.
 *
 * Displays the rarity label and the emoji icons for each active debuff.
 * Hovering a debuff chip shows the full description as a tooltip via `title`.
 *
 * Props:
 *   modifier — the active modifier object from s.activeModifier, or null/undefined
 */
export function ActiveModifierBadge({ modifier }) {
  if (!modifier) return null;

  return (
    <div className="active-modifier-badge" style={{ '--mod-color': modifier.color }}>
      <span className="active-modifier-rarity" style={{ color: modifier.color }}>
        ⚠️ {modifier.label}
      </span>
      <div className="active-modifier-debuffs">
        {modifier.debuffs.map(d => (
          <span
            key={d.id}
            className="active-modifier-debuff-chip"
            title={`${d.label}: ${d.desc}`}
          >
            {d.label.split(' ')[0]}
          </span>
        ))}
      </div>
    </div>
  );
}
